/*
//Snippet viejo
document.querySelector(':root').style.setProperty('--omc-chat-branding-header-background', '#EEB7CB'); // Header background (opcional)
document.querySelector(':root').style.setProperty('--omc-chat-branding-bubble-avatar-border', '#069'); // Avatar bubble border color (opcional)
document.querySelector(':root').style.setProperty('--omc-chat-paula-avatar',
'url(https://cdn.shopify.com/s/files/1/0502/5398/8024/files/Imagen_de_WhatsApp_2024-04-26_a_las_20.44.47_59bc6bcb.jpg?v=1714175358)'); // Avatar image (opcional)
var omc_s0 = document.createElement("script");
omc_s0.type = "text/javascript";
omc_s0.src = "https://cdn.jsdelivr.net/npm/js-md5@0.7.3/build/md5.min.js";
document.head.appendChild(omc_s0);
var omc_s1 = document.createElement("script");
omc_s1.type = "text/javascript";
//omc_s1.src = "https://chat.mind-lab.ai/webrocket.js";
//omc_s1.src=`https://chat.mind-lab.ai/webrocket.js${(window.location.href.indexOf("collections/reel-parts") > -1) && '?prefix_storage=nick' || ''}`
omc_s1.src = `https://chat.mind-lab.ai/webrocket.js${(window.location.href.includes("collections/reel-parts") || window.location.href.includes("pages/accurate-schematics-support-files")) ? '?prefix_storage=nick' : ''}`;

if (window.location.href.indexOf("collections/reel-parts") > -1 || window.location.href.indexOf("pages/accurate-schematics-support-files") > -1) {
  console.log("parts");
omc_s1.onload = () => {
omc.init({
publicKey:"68ff90b2ae",
webchat:{
publicKey:"c8a1af4a85",
demo : { avatar : "https://mind-lab.ai/wp-content/uploads/2024/05/Avatar-Customer-Service-5.png" },
aipid : "paula-us-accurate-m-parts-kb",
operadorId : 107,
preopen : { enabled : false },
style: { bottom:"90px"}
}
})
}
}else{
  console.log("no parts");
 omc_s1.onload = () => {
  omc.init({
    publicKey: '68ff90b2ae', // Solicitar a soporte webrocket publicKey
    webchat: {
      publicKey: 'c8a1af4a85', // Solicitar a soporte webchat publicKey
      style : {
        bottom: '90px',
      },
    }
  })
} 
}


document.head.appendChild(omc_s1);

*/

//Snippet nuevo:
/*
document.querySelector(":root").style.setProperty("--omc-chat-branding-header-background", "#EEB7CB"),
document.querySelector(":root").style.setProperty("--omc-chat-branding-bubble-avatar-border", "#069"),
document.querySelector(":root").style.setProperty("--omc-chat-paula-avatar", "url(https://cdn.shopify.com/s/files/1/0502/5398/8024/files/Imagen_de_WhatsApp_2024-04-26_a_las_20.44.47_59bc6bcb.jpg?v=1714175358)");
var omc_s0 = document.createElement("script");
omc_s0.type = "text/javascript",
omc_s0.src = "https://cdn.jsdelivr.net/npm/js-md5@0.7.3/build/md5.min.js",
document.head.appendChild(omc_s0);
var omc_s1 = document.createElement("script");
omc_s1.type = "text/javascript",
omc_s1.src = "https://chat.mind-lab.ai/webrocket.js".concat(window.location.href.includes("collections/reel-parts") || window.location.href.includes("pages/accurate-schematics-support-files") ? "?prefix_storage=nick" : ""),
window.location.href.indexOf("collections/reel-parts") > -1 || window.location.href.indexOf("pages/accurate-schematics-support-files") > -1 ? (console.log("parts"),
omc_s1.onload = function() {
    omc.init({
        publicKey: "68ff90b2ae",
        webchat: {
            publicKey: "c8a1af4a85",
            demo: {
                avatar: "https://mind-lab.ai/wp-content/uploads/2024/05/Avatar-Customer-Service-5.png"
            },
            aipid: "paula-us-accurate-m-parts-kb",
            operadorId: 107,
            preopen: {
                enabled: !1
            },
            style: {
                bottom: "90px"
            }
        }
    })
}
) : (console.log("no parts"),
omc_s1.onload = function() {
    omc.init({
        publicKey: "68ff90b2ae",
        webchat: {
            publicKey: "c8a1af4a85",
            style: {
                bottom: "90px"
            }
        },
        callback : () => {
        setTimeout(()=>{
          document.querySelector('.omc-chat-talk-bubble-principal .omc-chat-talktext').innerHTML += `<button class="omc-chat-button-2" style="background:#000000" onclick="omc.chat.config.aipid = 'paula-us-accurate-m-parts-kb';omc.chat.config.operadorId = 107;omc.chat.eventos.fire('chat_Opened'); document.querySelector('.omc-chat-container').classList.remove('omc-chat-container-minimized'); localStorage.setItem(OMC_CHAT_MINIMIZED, 'false'); omc_focusChat(false);">Customer Service Agent</button>`
          document.querySelector('.omc-chat-talk-bubble-principal .omc-chat-talktext button.omc-chat-button-1').addEventListener('click', () => { omc.chat.config.aipid = undefined;omc.chat.config.operadorId = undefined;omc.chat.eventos.fire('chat_Opened'); document.querySelector('.omc-chat-container').classList.remove('omc-chat-container-minimized'); localStorage.setItem(OMC_CHAT_MINIMIZED, 'false'); omc_focusChat(false); })
        
        }
          , 5000);
        
        }
    })
}
),
document.head.appendChild(omc_s1);
*/

//Snippet con blockeo
/*
document.querySelector(":root").style.setProperty("--omc-chat-branding-header-background", "#EEB7CB"),
document.querySelector(":root").style.setProperty("--omc-chat-branding-bubble-avatar-border", "#069"),
document.querySelector(":root").style.setProperty("--omc-chat-paula-avatar", "url(https://cdn.shopify.com/s/files/1/0502/5398/8024/files/Imagen_de_WhatsApp_2024-04-26_a_las_20.44.47_59bc6bcb.jpg?v=1714175358)");
var omc_s0 = document.createElement("script");
omc_s0.type = "text/javascript",
omc_s0.src = "https://cdn.jsdelivr.net/npm/js-md5@0.7.3/build/md5.min.js",
document.head.appendChild(omc_s0);
var omc_s1 = document.createElement("script");
omc_s1.type = "text/javascript",
omc_s1.src = "https://chat.mind-lab.ai/webrocket.js".concat(window.location.href.includes("collections/reel-parts") || window.location.href.includes("pages/accurate-schematics-support-files") ? "?prefix_storage=nick" : ""),
window.location.href.indexOf("collections/reel-parts") > -1 || window.location.href.indexOf("pages/accurate-schematics-support-files") > -1 ? (console.log("parts"),
omc_s1.onload = function() {
    omc.init({
        publicKey: "68ff90b2ae",
        webchat: {
            publicKey: "c8a1af4a85",
            demo: {
                avatar: "https://mind-lab.ai/wp-content/uploads/2024/05/Avatar-Customer-Service-5.png"
            },
            aipid: "paula-us-accurate-m-parts-kb",
            operadorId: 107,
            preopen: {
                enabled: !1
            },
            style: {
                bottom: "90px"
            }
        }
    })
}
) : (console.log("no parts"),
omc_s1.onload = function() {
    omc.init({
        publicKey: "68ff90b2ae",
        webchat: {
            publicKey: "c8a1af4a85",
            style: {
                bottom: "90px"
            }
        },
        callback : () => {
        setTimeout(()=>{
        	if(!omc.chat.mensajes || !omc.chat.mensajes.length){
        		omc.chat.config.widgetOpenAction = 'null'
        	}
        	
          document.querySelector('.omc-chat-talk-bubble-principal .omc-chat-talktext').innerHTML += `<button class="omc-chat-button-2" style="background:#000000" onclick="omc.chat.config.aipid = 'paula-us-accurate-m-parts-kb';omc.chat.config.operadorId = 107;omc.chat.eventos.fire('chat_Opened'); document.querySelector('.omc-chat-container').classList.remove('omc-chat-container-minimized'); localStorage.setItem(OMC_CHAT_MINIMIZED, 'false'); omc_focusChat(false);">Customer Service Agent</button>`
          document.querySelector('.omc-chat-talk-bubble-principal .omc-chat-talktext button.omc-chat-button-1').addEventListener('click', () => { omc.chat.config.aipid = undefined;omc.chat.config.operadorId = undefined;omc.chat.eventos.fire('chat_Opened'); document.querySelector('.omc-chat-container').classList.remove('omc-chat-container-minimized'); localStorage.setItem(OMC_CHAT_MINIMIZED, 'false'); omc_focusChat(false); })
        
        }
          , 4000);
        
        }
    })
}
),
document.head.appendChild(omc_s1);
*/


//snippet con agregado de botones
document.querySelector(":root").style.setProperty("--omc-chat-branding-header-background", "#EEB7CB"),
document.querySelector(":root").style.setProperty("--omc-chat-branding-bubble-avatar-border", "#069"),
document.querySelector(":root").style.setProperty("--omc-chat-paula-avatar", "url(https://cdn.shopify.com/s/files/1/0502/5398/8024/files/Imagen_de_WhatsApp_2024-04-26_a_las_20.44.47_59bc6bcb.jpg?v=1714175358)");
var omc_s0 = document.createElement("script");
omc_s0.type = "text/javascript",
omc_s0.src = "https://cdn.jsdelivr.net/npm/js-md5@0.7.3/build/md5.min.js",
document.head.appendChild(omc_s0);
var omc_s1 = document.createElement("script");
omc_s1.type = "text/javascript",
omc_s1.src = "https://chat.mind-lab.ai/webrocket.js".concat(window.location.href.includes("collections/reel-parts") || window.location.href.includes("pages/accurate-schematics-support-files") ? "?prefix_storage=nick" : ""),
window.location.href.indexOf("collections/reel-parts") > -1 || window.location.href.indexOf("pages/accurate-schematics-support-files") > -1 ? (console.log("parts"),
omc_s1.onload = function() {
    omc.init({
        publicKey: "68ff90b2ae",
        webchat: {
            publicKey: "c8a1af4a85",
            demo: {
                avatar: "https://mind-lab.ai/wp-content/uploads/2024/05/Avatar-Customer-Service-5.png"
            },
            aipid: "paula-us-accurate-m-parts-kb",
            operadorId: 107,
            preopen: {
                enabled: !1
            },
            style: {
                bottom: "90px",
              zIndex:999
            }
        }
    })
}
) : (console.log("no parts"),
omc_s1.onload = function() {
    omc.init({
        publicKey: "68ff90b2ae",
        webchat: {
            publicKey: "c8a1af4a85",
            style: {
                bottom: "90px",
              zIndex:999
            }
        },
        callback : () => {
        setTimeout(()=>{
          document.querySelector('html > div.omc-chat-container.omc-chat-speech-capable > div.omc-chat-write > span').setAttribute('contenteditable',false);
          document.querySelector('#omc-chat-body').innerHTML += `<div style="display: flex; flex-direction: column;height: 50vh;justify-content: flex-end;" id="appendMindlab"><p style='font-weight: bold;font-size: medium;'>Please choose the specific agent expertise you require:</p><button onclick="document.getElementById('appendMindlab').style.display = 'none';document.querySelector('html > div.omc-chat-container.omc-chat-speech-capable > div.omc-chat-write > span').setAttribute('contenteditable',true);" style="background:#000000;color: white;border: none;padding: 13px 15px;width: 100%;box-sizing: border-box !important;margin: 5px 0px 0px;border-radius: 12px;cursor: pointer;font-weight: bold;omc.chat.send('Hello!');">Sales AI Agent</button><button onclick="omc.chat.config.operadorId = 107;omc.chat.config.aipid = 'Nick_flows';omc.chat.send('Hello!');document.getElementById('appendMindlab').style.display = 'none';document.querySelector('html > div.omc-chat-container.omc-chat-speech-capable > div.omc-chat-write > span').setAttribute('contenteditable',true);" style="background:#000000;color: white;border: none;padding: 13px 15px;width: 100%;box-sizing: border-box !important;margin: 5px 0px 0px;border-radius: 12px;cursor: pointer;font-weight: bold;">Customer Service AI Agent</button></div>`;

        }
          , 100);
        
        }
    })
}
),
document.head.appendChild(omc_s1);